import React from 'react';
import { BankAccount, Card } from '@usealloy/component-library';

import { useEventTypeEvaluationsContext } from '../context';

const ExternalAccount = () => {
  const {
    evaluation: {
      final_response: {
        supplied: {
          account_class: accountClass,
          account_name: accountName,
          bank_account_number: accountNumber,
          bank_routing_number: routingNumber,
          card_network: cardNetwork,
          country_code: countryCode,
          currency,
        },
      },
    },
  } = useEventTypeEvaluationsContext();
  return (
    <Card collapsible header="External Account" contentGap={4}>
      <BankAccount
        accountNumber={accountNumber}
        cardNetwork={cardNetwork}
        class={accountClass}
        countryCode={countryCode}
        currencyCode={currency}
        isExternalAccount
        name={accountName}
        routingNumber={routingNumber}
        size="large"
        status="linked"
      />
    </Card>
  );
};

export default ExternalAccount;
